let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c3z4T")).then(() => parcelRequire('s579P'));